// import dependencies
import React from 'react';
import PropTypes from 'prop-types';

// import components
import { Link } from 'pcln-design-system';

const BaseLink = ({ url, ...props }) => <Link href={url} {...props} />;

BaseLink.propTypes = {

    /**
     * URL to link to
     */
    url: PropTypes.string
};

export default BaseLink;
